<template>
  <div id="app">

    <loader v-if="isLoading"/>

    <layout v-else/>

  </div>
</template>

<script>
  import Layout from './views/layout/Layout'
  import Loader from './components/Loader'

  export default {
    name: 'App',

    components: { Layout, Loader },

    data() {
      return {
        isLoading: true
      }
    },

    mounted() {
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    }
  }
</script>

<style lang="scss">
  @import "./assets/styles/main";
</style>
